var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMainTableOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_main_table_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.366667 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.694118 0 0 0 0 0.694118 0 0 0 0 0.694118 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_main_table_on",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "reorder_black_24dp-2-copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "reorder_black_24dp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,15 L20,15 C20.55,15 21,14.55 21,14 C21,13.45 20.55,13 20,13 L4,13 C3.45,13 3,13.45 3,14 C3,14.55 3.45,15 4,15 Z M4,19 L20,19 C20.55,19 21,18.55 21,18 C21,17.45 20.55,17 20,17 L4,17 C3.45,17 3,17.45 3,18 C3,18.55 3.45,19 4,19 Z M4,11 L20,11 C20.55,11 21,10.55 21,10 C21,9.45 20.55,9 20,9 L4,9 C3.45,9 3,9.45 3,10 C3,10.55 3.45,11 4,11 Z M3,6 C3,6.55 3.45,7 4,7 L20,7 C20.55,7 21,6.55 21,6 C21,5.45 20.55,5 20,5 L4,5 C3.45,5 3,5.45 3,6 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainTableOn);
export default __webpack_public_path__ + "static/media/icon_main_table_on.8a4b4be3261400cd8747b015765b27f9.svg";
export { ForwardRef as ReactComponent };